import React from 'react';
import './Cart.css'

const Cart = (props) => {
let {cart} = props;
console.log(cart)
let totalPrice = 0;
let shippingFee = 0;
let grandTotal = 0;

for(let product of cart){
    totalPrice = totalPrice + product.price;
    shippingFee = shippingFee + product.shipping;
}
let tex = (totalPrice * 10/100).toFixed(2)
tex = parseFloat(tex); 
grandTotal = totalPrice + shippingFee + tex;

    return (
        <div className='cart-design'>
            <h5>Order Summary</h5>
            <div>
                <p>Selected Items : {cart.length}</p>
                <p>Total Price : ${totalPrice}</p>
                <p>Total Shipping Charge : ${shippingFee}</p>
                <p>Tax: ${tex}</p>
                <h6>Grand Total: ${grandTotal}</h6>

            </div>
        </div>
    );
};

export default Cart;